    <div class="container-fluid" style="margin-top:70px; height:88vh">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card custom-card animated">
              <div class="card-body">
                  <h5 class="section-header">CHANGE PASSWORD</h5>
                  <form [formGroup]="changePasscodeForm" (ngSubmit)="changePasscode(changePasscodeForm)" >
                    <div class="form-group">
                      <label>Old Password</label>
                        <input type="password" name="old" formControlName="old" class="form-control" />
                        <p class="aler" *ngIf="!changePasscodeForm.controls['old'].valid &&
                        changePasscodeForm.controls['old'].touched"><small>*Required</small></p>
                    </div>

                    <div class="form-group">
                      <label>New Password</label>
                        <input type="password" name="pnew" formControlName="pnew" class="form-control" />
                        <p class="aler" *ngIf="!changePasscodeForm.controls['pnew'].valid &&
                        changePasscodeForm.controls['pnew'].touched"><small>*Required and must contain at least 6 characers</small></p>
                    </div>

                    <div class="form-group">
                        <label>Confirm New Passcode</label>
                        <input type="password" name="cnew" formControlName="cnew" class="form-control" />
                        <p class="aler" *ngIf="!changePasscodeForm.controls['cnew'].valid &&
                        changePasscodeForm.controls['cnew'].touched"><small>*Required and must contain at least 6 characers</small></p>
                        <p class="aler" *ngIf="changePasscodeForm.controls['pnew'].value != 
                        changePasscodeForm.controls['cnew'].value && 
                        (changePasscodeForm.controls['pnew'].touched || changePasscodeForm.controls['cnew'].touched)">
                          <small>Passwords do not match</small></p>
                    </div>

                    <div class="form-group">
                      <button type="submit" mat-raised-button color="primary" [disabled]="!changePasscodeForm.valid
                      || changePasscodeForm.controls['pnew'].value != changePasscodeForm.controls['cnew'].value">Save changes</button>  
                    </div>
                      
                  </form>
                </div>
              </div>
          </div>
        </div>
  </div>